import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';
import { convertToRS } from 'core/js/FormUtils';


export default function StitchingtaskInfo(){
  const { stitchingtaskObj} = useSelector((state)=>state.manufslice.stitchingtaskDashboard);
    return (
      <Box lg={12} sx={{ flexGrow: 1 }}>
      <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: { xs: window.screen.height - 250, lg: window.screen.height, }, borderRadius:2}}>
        
        <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{backgroundColor:'white',p:1, }}
        
      >
            
        <Grid item lg={4} xs={6}><FieldView2 label="Assigned Qty"  value={ stitchingtaskObj.assignedqty!==null && stitchingtaskObj.assignedqty!==undefined?stitchingtaskObj.assignedqty:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Received Qty"  value={ stitchingtaskObj.receivedqty!==null && stitchingtaskObj.receivedqty!==undefined?stitchingtaskObj.receivedqty:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Task Status Name"  value={ stitchingtaskObj.taskstatusname!==null && stitchingtaskObj.taskstatusname!==undefined?stitchingtaskObj.taskstatusname:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="orderId"  value={ stitchingtaskObj.orderid!==null && stitchingtaskObj.orderid!==undefined?stitchingtaskObj.orderid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Product Id"  value={ stitchingtaskObj.productid!==null && stitchingtaskObj.productid!==undefined?stitchingtaskObj.productid:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Product Name"  value={ stitchingtaskObj.productname!==null && stitchingtaskObj.productname!==undefined?stitchingtaskObj.productname:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Worker Name"  value={ stitchingtaskObj.workername!==null && stitchingtaskObj.workername!==undefined?stitchingtaskObj.workername:'NOT KNONWN' }/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Earning"  value={ convertToRS(stitchingtaskObj.earning)}/></Grid>
        <Grid item lg={4} xs={6}><FieldView2 label="Stitching Rate"  value={ convertToRS(stitchingtaskObj.stitchingrate)}/></Grid>
      </Grid>
      </Grid>
      </Box>
    )
}